<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12">
				<h3 class="animated slideInDown">
					<span><fa-icon icon="globe-americas" /> Servidores de envio</span>

					<button type="button" @click="clickNovo()" class="btn float-right btn-sm  btn-outline-primary">
						<fa-icon icon="plus"/> Adicionar
					</button>
				</h3>
			</div>
		</div>

		<form style="margin-top:20px" @submit.prevent="validateBeforeSubmit">

			<flCarregando v-if="carregando" />

			<div v-if="!carregando">
				<div  class="row form-group" v-for="(item, index) in form.envios" :key="index">
					<label for="inputPassword" class="col-lg-2 col-12 col-form-label col-form-label-sm">Servidor {{index + 1}}</label>
					<div class="col-lg-5 col-8">
						<select v-model="item.idServidorEnvio"
									:class="{'is-invalid' : item.erro != ''}"
								class="form-control form-control-sm">
							<option value="0">Escolha</option>
							<option v-for="it in servidores_" :key="it.id" :value="it.id">{{it.tipo}} - {{it.descricao}}</option>
						</select>
						<span  class="invalid-feedback" v-show="item.erro != ''">{{ item.erro }}</span>
					</div>
					<div class="col-lg-2 col-4">
						<button @click="form.envios.splice(index, 1)" class="btn btn-sm btn-outline-danger">
							<fa-icon :icon="['far', 'trash-alt']" /> Excluir
						</button>
					</div>
				</div>

				<hr />

				<div class="form-group row">
					<div class="col-lg-12">

						<button class="btn btn-success float-right btn-sm btn-sm">
							<fa-icon icon="check" transform="left-3" /> SALVAR
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import _ from 'lodash'
import axios from '../../../routers/axios'
import flCarregando from '../../../components/carregando/main.vue'
export default {

	components: {
		flCarregando
	},

	computed: {
		servidores_ () {
			return _.orderBy(this.servidores, 'tipo', 'asc')
		},
	},

	data(){
		return {

			servidores: [],
			carregando: false,
			form: {
				id: 0,
				tipo: "",
				imei: "",
				prefixo: "",
				envios: [
					{
						id: 0,
						idServidorEnvio: 0,
						idEquipamento: 0,
						erro: "",
					}
				],
			}
		}
	},

	mounted () {
		axios.get(this._getUrl('api/servidorenvio')).then(response => {
			if(response.status == 200){
				this.servidores = response.data
			}
		})
	},

	methods: {

		editar(item){
			this.form.id = item.id
			this.form.tipo = item.tipo
			this.form.imei = item.imei
			this.form.prefixo = item.prefixo
			this.carregaServidores(item.id);
		},

		carregaServidores(id){
			this.carregando = true
			axios.get(this._getUrl(`api/equipamentoenvio/${id}`)).then(response => {
				this.carregando = false
				this.form.envios = response.data.map(item => {
					item.erro = ""
					return item
				})
			})
		},


		clickNovo(){
			this.form.envios.push({
						id: 0,
						idServidorEnvio: 0,
						idEquipamento: this.form.id,
						erro: "",
					})
		},

		validateBeforeSubmit() {
			var passou = true
			for(var i in this.form.envios){
				var qtd = 0
				for(var j in this.form.envios){
					if(this.form.envios[i].idServidorEnvio == this.form.envios[j].idServidorEnvio){
						qtd++
					}
				}

				if(qtd > 1){
					passou = false
					this.form.envios[i].erro = "Esse servidor está duplicado."
					break
				}
			}

			if(passou){
				this.salva()
			}
		},

		salva(){

			var data = []
			for(var i in this.form.envios){
				if(this.form.envios[i].idServidorEnvio != 0){
					this.form.envios[i].idEquipamento =this.form.id
					data.push(this.form.envios[i])
				}
			}

			this.$notify.loadIn('Salvando')

			axios.put(this._getUrl(`api/equipamentoenvio/${this.form.id}`), data).then(response => {
				this.$notify.show('success', 'Servidores salvo.')
			})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/servidor.vue